import { render, staticRenderFns } from "./IntegraIUSA.vue?vue&type=template&id=83606f3e&"
import script from "./IntegraIUSA.vue?vue&type=script&lang=js&"
export * from "./IntegraIUSA.vue?vue&type=script&lang=js&"
import style0 from "./IntegraIUSA.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports